import './controls.css';

export interface SegmentedOption {
  value: string;
  label?: string;
}

export interface SegmentedOptions {
  value: string;
  options: SegmentedOption[];
  onChange: (value: string) => void;
  ariaLabel?: string;
}

export interface SegmentedHandle {
  readonly el: HTMLElement;
  setValue(value: string): void;
  destroy(): void;
}

export function createSegmented(opts: SegmentedOptions): SegmentedHandle {
  let value = opts.value;

  const el = document.createElement('div');
  el.className = 'fg-segmented';
  el.setAttribute('role', 'radiogroup');
  if (opts.ariaLabel) el.setAttribute('aria-label', opts.ariaLabel);

  const items: Array<{ btn: HTMLButtonElement; value: string }> = [];

  for (const opt of opts.options) {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'fg-segmented__item';
    btn.textContent = opt.label ?? opt.value;
    btn.setAttribute('role', 'radio');
    btn.dataset.value = opt.value;
    el.appendChild(btn);
    items.push({ btn, value: opt.value });
  }

  function applyActive() {
    for (const { btn, value: v } of items) {
      const active = v === value;
      btn.classList.toggle('fg-segmented__item--active', active);
      btn.setAttribute('aria-checked', String(active));
    }
  }
  applyActive();

  const handler = (e: MouseEvent) => {
    const target = e.target as HTMLElement;
    const next = target.dataset.value;
    if (!next || next === value) return;
    value = next;
    applyActive();
    opts.onChange(next);
  };
  el.addEventListener('click', handler);

  return {
    el,
    setValue(v) {
      value = v;
      applyActive();
    },
    destroy() {
      el.removeEventListener('click', handler);
      el.remove();
    },
  };
}
